import PropTypes from 'prop-types'
import c from 'classnames'
import styles from './Toggle.module.scss'

const Toggle = ({ isActive }) => (
  <div className={c(styles.base, { [styles.active]: isActive })}>
    <div className={c(styles.dot, 'b-brand10')} />
  </div>
)

Toggle.defaultProps = { isActive: false }
Toggle.propTypes = { isActive: PropTypes.bool }

export default Toggle
